import { Component, effect, inject, Input } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { UserService } from '../userService/user-service';
import { ToastService } from '../toast/toast';

@Component({
    standalone: true,
    selector: 'abs-billing-issue-warning',
    imports: [],
    template: ``
})
export class BillingIssueWarningComponent {
    userService = inject(UserService);
    router = inject(Router);
    platform = inject(Platform);
    toast = inject(ToastService);

    @Input()
    subscriptionUrl = '/subscription';

    private warningShown = false;

    constructor() {
        effect(() => {
            const user = this.userService.user();
            if (!user) return;

            const hasActiveBillingIssue = user['hasActiveBillingIssue'];
            const isCancelledDueToBillingIssue = user['isCancelledDueToBillingIssue'];

            if (!hasActiveBillingIssue && !isCancelledDueToBillingIssue) return;
            if (this.warningShown) return;
            this.warningShown = true;

            const isNative = this.platform.is('ios') || this.platform.is('android');
            const isStripeOnNative = isNative && this.hasActiveStripeSubscription(user);

            let message: string;
            if (isCancelledDueToBillingIssue) {
                message = isStripeOnNative
                    ? 'Your subscription was cancelled due to a billing issue. Please log into the web app to manage your subscription.'
                    : 'Your subscription was cancelled due to a billing issue.';
            } else {
                message = isStripeOnNative
                    ? "We're having trouble processing your subscription renewal. Please log into the web app to update your payment details."
                    : "We're having trouble processing your subscription renewal.";
            }

            const buttons = isStripeOnNative
                ? [{ text: 'Close', role: 'cancel' as const }]
                : [
                      { text: 'Close', role: 'cancel' as const },
                      { text: 'Manage Subscription', role: 'ok' as const }
                  ];

            this.toast.showToast('Billing Issue', message, { color: 'danger', buttons, duration: 0 }).then((res) => {
                if (res.role === 'ok' && this.subscriptionUrl) {
                    this.router.navigate([this.subscriptionUrl]);
                }
            });
        });
    }

    private hasActiveStripeSubscription(user: any): boolean {
        const subscriptions = user['subscriptions'];
        if (!subscriptions) return false;
        return Object.values(subscriptions).some((sub: any) => sub.store === 'stripe' && new Date(sub.expires_date) > new Date());
    }
}
